export default {
      id: "check-usage",
      viewBox: "289 435 14 15",
      url: __webpack_public_path__ + "app/svg/sprite.svg#check",
      toString: function () {
        return this.url;
      }
    }